import { ContentStrategyType } from 'types'

export const SmallThumbMap: Record<ContentStrategyType, string> = {
  [ContentStrategyType.EducationalContent]:
    'https://res.cloudinary.com/almanac/image/upload/v1775755660/onboarding_assets/content_optimization_step/small/educational_content_xmd36t.png',
  [ContentStrategyType.QuickTips]:
    'https://res.cloudinary.com/almanac/image/upload/v1775755659/onboarding_assets/content_optimization_step/small/quick_tips_kpjfbn.png',
  [ContentStrategyType.ThoughtLeadership]:
    'https://res.cloudinary.com/almanac/image/upload/v1775755417/onboarding_assets/content_optimization_step/small/thoughtleadersmall_gu8i3v.jpg',
  [ContentStrategyType.LifestyleContent]:
    'https://res.cloudinary.com/almanac/image/upload/v1775755660/onboarding_assets/content_optimization_step/small/lifestyle_content_qrrvwb.png',
  [ContentStrategyType.ProblemSolution]:
    'https://res.cloudinary.com/almanac/image/upload/v1775755658/onboarding_assets/content_optimization_step/small/problem_solution_small_yvuyez.png',
  [ContentStrategyType.ProductEducation]:
    'https://res.cloudinary.com/almanac/image/upload/v1775755657/onboarding_assets/content_optimization_step/small/product_education_pzggyb.png',
  [ContentStrategyType.OfferAndServices]:
    'https://res.cloudinary.com/almanac/image/upload/v1775755660/onboarding_assets/content_optimization_step/small/offer_services_zyzmll.jpg',
  [ContentStrategyType.OfferAndPromotion]:
    'https://res.cloudinary.com/almanac/image/upload/v1775755660/onboarding_assets/content_optimization_step/small/offer_services_zyzmll.jpg',
}

export const ImgMap: Record<ContentStrategyType, string> = {
  [ContentStrategyType.EducationalContent]:
    'https://res.cloudinary.com/almanac/image/upload/v1773861461/onboarding_assets/content_optimization_step/educational_content_ihfa9u.png',
  [ContentStrategyType.QuickTips]:
    'https://res.cloudinary.com/almanac/image/upload/v1773861517/onboarding_assets/content_optimization_step/quick_tips_ghdw8h.png',
  [ContentStrategyType.ThoughtLeadership]:
    'https://res.cloudinary.com/almanac/image/upload/v1773861551/onboarding_assets/content_optimization_step/thought_leadership_mr5z8d.png',
  [ContentStrategyType.LifestyleContent]:
    'https://res.cloudinary.com/almanac/image/upload/v1773859301/onboarding_assets/content_optimization_step/lifestyle_content_rlrfsc.png',
  [ContentStrategyType.ProblemSolution]:
    'https://res.cloudinary.com/almanac/image/upload/v1775755322/onboarding_assets/content_optimization_step/problem_solution_bwpwge.png',
  [ContentStrategyType.ProductEducation]:
    'https://res.cloudinary.com/almanac/image/upload/v1773861624/onboarding_assets/content_optimization_step/product_education_z3eyr3.png',
  [ContentStrategyType.OfferAndServices]:
    'https://res.cloudinary.com/almanac/image/upload/v1773861680/onboarding_assets/content_optimization_step/offer_and_services_oseisd.png',
  [ContentStrategyType.OfferAndPromotion]:
    'https://res.cloudinary.com/almanac/image/upload/v1773861680/onboarding_assets/content_optimization_step/offer_and_services_oseisd.png',
}
